// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"11":"6a025940","38":"17826cf3","323":"830700c4","346":"8e7693ba","390":"db108f5f","895":"4afcdbc4","986":"907f71e9"}[chunkId] + ".js";
};